// extracted by mini-css-extract-plugin
module.exports = {"productCardBase":"_2GaIwJ","imageContainer":"Qaj0un","name":"_36XnpX","upchargePrice":"_2hl34e"};